import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators, AbstractControl} from '@angular/forms';
import {NgxSpinnerService} from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {DatePipe} from '@angular/common';
import {Router} from '@angular/router';
import {AccessService} from '../service/access.service';
import {ModalTermsVisitorComponent} from './modal-terms-visitor/modal-terms-visitor.component';
import {CustomsValidators} from '../../validators/custom.validators'
import {ModErrorComponent} from '../modals/mod-error/mod-error.component';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

@Component({
  selector: 'app-access-visitor',
  templateUrl: './access-visitor.component.html',
  styleUrls: ['./access-visitor.component.css']
})
export class AccessVisitorComponent implements OnInit {
  //forms
  formAccessVisitor: UntypedFormGroup;
  RadioGroup: UntypedFormGroup;
  i = 0;
  buttonEnable: boolean= true

  //calendar
  todayDate: Date;
  minDateEnd: string;
  maxDate: Date;
  sDate: string;
  eDate: string;
  maxDateTo: Date;

  //service
  siteCodeCC: string
  zoneCodeCC: string
  oneSapZone: string
  oneSapSite: string
  selectZone: any = [];
  site: any = [];
  visitors: any = [];
  selectBusiness: any = [];
  selectSubZone: any = [];
  formTableEntry: any;
  selectCountry: any = [];
  description: string = null;
  descriptionSite: string = null;
  descriptionSubzone: string = null;
  formRadio: UntypedFormGroup;
  radioPress = false;
  controlNationalError = false;
  controlCountryError = false;
  controlDateAddError = false;
  controlRepeatPerson = false;
  controlNotFoundError = false;
  controlPeopleInError = false;
  controlPeopleInError1 = false;
  controlFirstName = false;
  controlLastName = false;
  controlEmail = false;
  controlEmailFormat = false;
  controlNumPeople = false;
  submited = false;
  dataEntry: any;
  approvers: any;
  controlNotFoundEmployee = false;
  controlNotFoundContractor = false;


  numberPattern: any = /^([0-9])*$/;
  // /^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/;


  approverFacilityZone: any;
  approverFacilitySubZone: any;
  options: any[];
  optionsApproverSubzone: any[];


  constructor(
    private formBuilder: UntypedFormBuilder,
    private dataApi: AccessService,
    private spinner: NgxSpinnerService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private router: Router) {
    this.dataEntry = [];

    this.RadioGroup = new UntypedFormGroup({
      radioBtn: new UntypedFormControl()
    });
    this.RadioGroup.controls['radioBtn'].setValue(String('false'));
    this.formTableEntry = [];
    this.approvers = [];
    this.todayDate = new Date();
    this.maxDate = new Date((this.todayDate.getFullYear() + environment.MaxYeardateAccessForms), this.todayDate.getMonth(), this.todayDate.getDate());
    this.minDateEnd = this.transformDate(new Date());
    this.maxDateTo = new Date((this.todayDate.getFullYear() + environment.MaxYeardateAccessForms), this.todayDate.getMonth(), this.todayDate.getDate());
  }

  public toFormControl(point: AbstractControl): UntypedFormControl {
    return point as UntypedFormControl;
  }

  getlang() {

    return sessionStorage.getItem('lang');
  }

  transformDate(date: Date) {
    return (this.datePipe.transform(date, 'yyyy-MM-dd'));
  }

  getVisitorAccess() {
    this.spinner.show("loading");
    this.dataApi.getVisitorAccess().subscribe((data: any) => {
      this.spinner.hide("loading");
      this.site = data.sites;
      this.selectBusiness = data.businessUnits;
      this.selectCountry = data.countries;
      this.visitors = data.visitorsType;
    }, (err) => {
      if(err.error.error !== 'Invalid token.') {
        this.spinner.hide("loading");
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',

        });
      }
    });
  }

  openDialog() {
    this.dialog.open(ModalTermsVisitorComponent, {panelClass: 'myapp-no-padding-dialog'}).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        this.formAccessVisitor.controls['Confirm'].setValue(true);
      }
    });
  }

  changeSelectSite(siteId) {
    this.ApproverId.setValue([]);
    this.approverFacilityZone = null;
    this.approverFacilitySubZone = null;
    for (const siteOP of this.site) {
      if (siteOP.id === Number(siteId)) {

        if (siteOP.description === undefined) {
          this.descriptionSite = null;
          this.oneSapSite = null;
        } else {
          this.descriptionSite = siteOP.description;
          this.oneSapSite = siteOP.code1Sap;
          this.siteCodeCC = siteOP.codeCC;
        }


        if (this.oneSapSite==='0000')
        {
          
          this.buttonEnable = false
         
        }
        else 
        {
          this.buttonEnable= true

        }
        this.selectZone = siteOP.zones;
      }
      this.formAccessVisitor.controls['zoneId'].setValue('');
      //this.cleanSubzoneBU();
      // this.descriptionSite = siteOP.description;
    }
  }

  cleanSubzoneBU() {
    this.formAccessVisitor.controls['accessApproverId'].setValue('');
    this.formAccessVisitor.controls['bussinesUnitID'].setValue('');
    this.formAccessVisitor.controls['subZoneId'].setValue('');
    this.descriptionSubzone = null;
    this.approverFacilitySubZone = null;


  }

  validation48hours() {

    let dateToday = new Date();
    if (this.formAccessVisitor.controls['dateStart'].value == '' || this.formAccessVisitor.controls['dateStart'].value == undefined) {
      return false;
    }
    const startDate = new Date(this.datePipe.transform(this.formAccessVisitor.controls['dateStart'].value, "MM/dd/yyyy"));
    const today = new Date(this.datePipe.transform(dateToday, "MM/dd/yyyy"));
    let Difference_In_Days48 = (startDate.getTime() - today.getTime()) / (1000 * 3600 * 24);
    if (Difference_In_Days48 <= 2) {
      return true;
    } else {
      return false;
    }

  }

  validation1Day() {
    if (this.formAccessVisitor.controls['dateStart'].value == '' || this.formAccessVisitor.controls['dateStart'].value == undefined) {
      return false;
    }
    const startDate = new Date(this.datePipe.transform(this.formAccessVisitor.controls['dateStart'].value, "MM/dd/yyyy"));
    const End = new Date(this.datePipe.transform(this.formAccessVisitor.controls['dateEnd'].value, "MM/dd/yyyy"));
    let Difference_In_1Day = (End.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
    if (Difference_In_1Day > 1) {
      return true;
    } else {
      return false;
    }

  }

  getApproverSubZone(idSubzone) {
    this.formAccessVisitor.controls['accessApproverId'].setValue('');
    for (const subZoneOP of this.selectSubZone) {
      if (subZoneOP.id === Number(idSubzone)) {
        if (subZoneOP.description === undefined) {
          this.descriptionSubzone = null;

        } else {
          this.descriptionSubzone = subZoneOP.description;
        }
        //if (subZoneOP.facilityState) {
        if (false) {
          this.spinner.show("loading");
          this.dataApi.getPeopleSearchByMDMID(subZoneOP.approverId).subscribe(
            (response: any) => {
              this.approverFacilitySubZone = { //llamada al get por mdmid
                fullName: response.firstName + " " + response.lastName,
                email: response.email,
                phone: response.phoneNumber,
                priority: subZoneOP.priority,
                state: subZoneOP.facilityState,
                mdmid: subZoneOP.approverId
              }
              this.spinner.hide("loading");
            },
            (err) => {
              this.spinner.hide("loading");
              if(err.error.error !== 'Invalid token.') {
                this.dialog.open(ModErrorComponent, {
                  width: 'auto',
                  panelClass: 'myapp-no-padding-dialog',

                });
              }
            }
          )
        } else {
          this.approverFacilitySubZone = null;
        }
      }
    }
    this.spinner.show("loading");
    this.dataApi.getApproverVisitorSubZone(idSubzone).subscribe((data: any) => {
      this.spinner.hide("loading");
      if (data === undefined || data === null) {
        this.approvers = [];
        this.optionsApproverSubzone = []
        this.filteredOptionsApproverSubzone = this.formAccessVisitor.controls.accessApproverId.valueChanges
          .pipe(
            startWith(''),
            map(value => typeof value === 'string' ? value : value.name),
            map(name => name ? this._filterSubzoneApprovers(name) : this.optionsApproverSubzone.slice())
          );
      } else {
        this.approvers = data;
        this.optionsApproverSubzone = data.sort((a, b) => a[data.name] > b[data.name] ? 1 : a[data.name] === b[data.name] ? 0 : -1);
        ;
        this.filteredOptionsApproverSubzone = this.formAccessVisitor.controls.accessApproverId.valueChanges
          .pipe(
            startWith(''),
            map(value => typeof value === 'string' ? value : value.name),
            map(name => name ? this._filterSubzoneApprovers(name) : this.optionsApproverSubzone.slice())
          );

      }
    }, (err) => {
      this.spinner.hide("loading");
      if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',

        });
      }
    });
  }


  changeSelectZone(zoneId) {
    for (const zoneOP of this.selectZone) {
      if (zoneOP.id === Number(zoneId)) {
        if (zoneOP.subZones === undefined) {
          this.selectSubZone = [];
          this.oneSapZone = null;
        } else {
          this.selectSubZone = zoneOP.subZones;
        }
        this.description = zoneOP.description;
        this.oneSapZone = zoneOP.code1Sap;
        this.zoneCodeCC = zoneOP.codeCC;
        //if (zoneOP.facilityState) {
        if (false) { // diabled
          this.spinner.show("loading");
          this.dataApi.getPeopleSearchByMDMID(zoneOP.approverId).subscribe(
            (response: any) => {
              this.approverFacilityZone = { //llamada al get por mdmid
                fullName: response.firstName + " " + response.lastName,
                email: response.email,
                phone: response.phoneNumber,
                priority: zoneOP.priority,
                state: zoneOP.facilityState,
                mdmid: zoneOP.approverId
              }
              this.spinner.hide("loading");
            },
            (err) => {
              this.spinner.hide("loading");
              if(err.error.error !== 'Invalid token.') {
                this.dialog.open(ModErrorComponent, {
                  width: 'auto',
                  panelClass: 'myapp-no-padding-dialog',

                });
              }
            }
          )
        } else {
          this.approverFacilityZone = null;
        }
      }
      this.cleanSubzoneBU();
    }
  }

  changeBuGetApprover(idBu) {
    this.formAccessVisitor.controls.accessApproverId.setValue('');
    this.spinner.show("loading");
    this.dataApi.getApproverVisitorBu(idBu, this.oneSapSite, this.oneSapZone).subscribe((data: any) => {
      this.spinner.hide("loading");
      if (data === undefined || data === null) {
        this.approvers = [];
      } else {
        this.approvers = data;
      }
    }, (err) => {
      this.spinner.hide("loading");
      if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',

        });
      }
    });
  }

  changeNotBuGetApprover(idZone) {
    this.ApproverId.setValue([]);
    this.changeSelectZone(idZone)
    this.formAccessVisitor.controls.accessApproverId.setValue('');
    this.spinner.show("loading");
    //this.oneSapZone=idZone;
    this.dataApi.getApproversNotBu(this.oneSapSite, this.oneSapZone).subscribe((data: any) => {
      this.spinner.hide("loading");
      if (data === undefined || data === null) {
        this.approvers = [];
      } else {
        this.approvers = data;
        this.options = data;
        this.filteredOptions = this.ApproverId.valueChanges
          .pipe(
            startWith(''),
            map(value => typeof value === 'string' ? value : value.name),
            map(name => name ? this._filter(name) : this.options.slice())
          );
      }
    }, (err) => {
      this.spinner.hide("loading");
      if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',

        });
      }
    });
  }

  // myControl = new FormControl();
  ApproverId = new UntypedFormControl([Validators.required])
  // options= this.approvers;
  filteredOptions: Observable<any>;
  filteredOptionsApproverSubzone: Observable<any>;

  private _filterSubzoneApprovers(name: string): any[] {
    const filterValue = name.toLowerCase();
    const devolver = this.optionsApproverSubzone.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    return devolver;
  }

  displayFn(user: any): string {
    return user.mdmid && user.name ? user.name : '';
  }

  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }

  clearPersonDate() {

    let dateToSelected = new Date(this.formAccessVisitor.controls['dateStart'].value)
    this.maxDateTo = new Date(dateToSelected.setFullYear(dateToSelected.getFullYear() + environment.MaxYeardateAccessForms))

    this.formAccessVisitor.controls['dateEnd'].setValue('')
    this.formAccessVisitor.controls['dateIndefinite'].setValue(false)
    this.dataEntry = [];
  }

  goTo(id: string) {
    const el = document.getElementById(id);
    el.scrollIntoView();
  }

  add() {

    this.spinner.show("loading");
    this.radioPress = true;
    this.controlPeopleInError = false;
    this.controlNationalError = false;
    this.controlDateAddError = false;
    this.controlRepeatPerson = false;
    this.controlFirstName = false;
    this.controlLastName = false;
    this.controlEmail = false;
    this.controlEmailFormat = false;
    this.controlNotFoundError = false;
    this.controlCountryError = false;
    this.controlNotFoundEmployee = false;
    this.controlNotFoundContractor = false;
    let doSearch = true;

    if (this.formRadio.value.firstName === '' && this.formRadio.value.lastName === '' && this.formRadio.value.email === '') { //validation of nationality pending
      this.spinner.hide("loading");
      this.controlFirstName = true;
      this.controlLastName = true;
      this.controlEmail = true;
      return;
    } else if (this.formRadio.value.firstName === '' && this.formRadio.value.lastName === '') {
      this.spinner.hide("loading");
      this.controlFirstName = true;
      this.controlLastName = true;
      return;
    } else if (this.formRadio.value.firstName === '') {
      this.spinner.hide("loading");
      this.controlFirstName = true;
      return;
    } else if (this.formRadio.value.lastName === '' && this.formRadio.value.email === '') {
      this.spinner.hide("loading");
      this.controlLastName = true;
      this.controlEmail = true;
      return;
    } else if (this.formRadio.value.lastName === '') {
      this.spinner.hide("loading");
      this.controlLastName = true;
      return;
    } else if (this.formRadio.value.firstName === '' && this.formRadio.value.email === '') {
      this.spinner.hide("loading");
      this.controlFirstName = true;
      this.controlEmail = true;
      return;
    } else if (this.formRadio.value.email === '') {
      this.spinner.hide("loading");
      this.controlEmail = true;
      return;
    } else if (this.formRadio.controls.email.invalid) {
      this.spinner.hide("loading");
      this.controlEmailFormat = true;
      return;
    } else if (this.formRadio.value.ID === '') {
      this.spinner.hide("loading");
      return;
    } else if (this.formRadio.value.document === 'nationalId' && this.formRadio.controls['ID'].hasError('validateRUN')) {
      this.spinner.hide("loading");
      return;
    }


    if (!this.formRadio.controls['document'].hasError('required')) {
      if (!this.formRadio.controls['ID'].hasError('required')) {
        if (this.formRadio.value.document === 'passportNumber' &&
          this.formRadio.controls['countryId'].hasError('required')) { //validation of nationality pending
          this.spinner.hide("loading");
          this.controlCountryError = true;
          return;
        }
        for (const person of this.dataEntry) {
          if (this.formRadio.value.document === 'nationalId' && person.nationalId != '') {

            if (String(person.nationalId).toLowerCase() === String(this.formRadio.value.ID).toLowerCase()) {
              doSearch = false;
              this.spinner.hide("loading");

              break;
            }
          } else if (this.formRadio.value.document === 'passportNumber' && person.passportNumber != '') {

            if (String(person.passportNumber).toLowerCase() === String(this.formRadio.value.ID).toLowerCase() &&
              (String(this.formRadio.value.countryId) === person.nationality)) {
              doSearch = false;
              this.spinner.hide("loading");

              break;
            }
          }
        }

        if (doSearch) {
          this.dataApi.getVisitorPeople(this.formRadio.value.document, this.formRadio.value.ID.toLowerCase(), this.formRadio.value.countryId, this.oneSapSite).subscribe((data: any) => {
            if (data.visitorIn === false) {

              this.controlNotFoundError = true;
            } else {
              const newEntry = {
                document: this.formRadio.value.document,
                firstName: this.formRadio.value.firstName,
                lastName: this.formRadio.value.lastName,
                email: this.formRadio.value.email,
                nationality: this.formRadio.value.countryId,
                completedForm: "false",
                qualificationStatus: "1"

              };
              if (this.formRadio.value.document === 'nationalId') {
                let IdSPLIT = this.formRadio.value.ID.split('.').join('')
                this.formRadio.controls['ID'].setValue(IdSPLIT)
                Object.assign(newEntry, {
                  nationalId: this.formRadio.value.ID,
                  nationality: "Chile",
                  passportNumber: "",
                  phoneNumber: ""
                });
                this.dataEntry.push(newEntry)

                //Clean Field

                this.formRadio.controls['firstName'].setValue('');
                this.formRadio.controls['lastName'].setValue('');
                this.formRadio.controls['email'].setValue('');
                this.formRadio.controls['ID'].setValue('');
                this.formRadio.controls['ID'].setErrors(null);
              }
              if (this.formRadio.value.document === 'passportNumber') {
                Object.assign(newEntry, {passportNumber: this.formRadio.value.ID, nationalId: "", phoneNumber: ""});
                this.dataEntry.push(newEntry);

                //Clean Field

                this.formRadio.controls['firstName'].setValue('')
                this.formRadio.controls['lastName'].setValue('')
                this.formRadio.controls['email'].setValue('')
                this.formRadio.controls['ID'].setValue('');
                this.formRadio.controls['ID'].setErrors(null);
                this.formRadio.controls['countryId'].setValue('');


              }

            }
            this.spinner.hide("loading");
          }, (err) => {
            this.spinner.hide("loading");
            if(err.error.error !== 'Invalid token.') {
              if(err.error.message.includes('Employee')) {
                this.controlNotFoundEmployee = true;
              } else if(err.error.message.includes('Contractor')){
                this.controlNotFoundContractor = true;
              }
              else {
                this.dialog.open(ModErrorComponent, {
                  width: 'auto',
                  panelClass: 'myapp-no-padding-dialog',

                });
              }
            }
          });
        } else {
          this.spinner.hide("loading");
          this.controlRepeatPerson = true;
        }
      }
    } else {
      this.spinner.hide("loading");
    }
    ;
  }

  deletePeople(i) {
    this.dataEntry.splice(i, 1);
  }

  cleanBulk() {
    this.submited = false;
    this.formRadio.controls.ID.setValue('');
    this.formRadio.controls.document.setValue('nationalId');
    this.formRadio.controls.firstName.setValue('');
    this.formRadio.controls.lastName.setValue('');
    this.formRadio.controls.email.setValue('');
    this.formRadio.controls.numPeople.setValue('');
    this.formRadio.controls.countryId.setValue('');
  }

  cleanManual() {
    this.dataEntry = [];
    this.formRadio.controls.ID.setValue('');
    this.formRadio.controls.countryId.setValue('');
    this.formRadio.controls.document.setValue('nationalId');
    this.submited = false;
  }

  changeLimitDate() {

    switch (this.formAccessVisitor.controls['dateIndefinite'].value) {
      case true:

        let dateToSelected = new Date(this.formAccessVisitor.controls['dateStart'].value)
        let dateUndefined = new Date(dateToSelected.setFullYear(dateToSelected.getFullYear() + environment.MaxYeardateAccessForms))
        this.formAccessVisitor.patchValue({dateEnd: dateUndefined})

        break;
      case false:

        this.formAccessVisitor.controls['dateEnd'].setValue("")
        break;
    }
  }

  ngOnInit() {
    this.formAccessVisitor = this.formBuilder.group({
      classification: ['', Validators.required],
      siteId: ['', Validators.required],
      zoneId: ['', Validators.required],
      subZoneId: ['', Validators.required],
      bussinesUnitID: ['', Validators.required],
      accessApproverId: ['', Validators.required],
      purpuse: [''],
      Confirm: [false, Validators.required],
      dateStart: ['', Validators.required],
      dateEnd: ['', Validators.required],
      facilityApproverId: [''],
      facilityPriority: [true],
      dateIndefinite: [false]
    });
    this.formRadio = this.formBuilder.group({
      options: ['', Validators.required],
      // ID: ['', Validators.required],
      ID: ['', [Validators.required, Validators.maxLength(10), CustomsValidators.validateRUN]],
      document: ['nationalId', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      countryId: ['', Validators.required],
      numPeople: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.min(2)]]

    });
    this.getVisitorAccess();
  }

  get numPeople() {
    return this.formRadio.get('numPeople');
  }


  onSubmit() {
    this.spinner.show("loading");
    this.submited = true;
    this.controlPeopleInError = false;
    this.controlPeopleInError1 = false;


    if (this.formAccessVisitor.controls['classification'].hasError('required')
      || this.formAccessVisitor.controls['siteId'].hasError('required')
      || this.formAccessVisitor.controls['zoneId'].hasError('required')) {
      this.goTo('siteSection');
      this.spinner.hide("loading");
      return;
    }
    if (this.RadioGroup.value.radioBtn === true && (this.formAccessVisitor.controls['subZoneId'].hasError('required') || this.formAccessVisitor.controls['accessApproverId'].hasError('required'))

    ) {
      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }
    if (this.RadioGroup.value.radioBtn === 'false' && (this.ApproverId.value.mdmid === '' || this.ApproverId.value.mdmid === undefined || this.ApproverId.value.mdmid === null)) {

      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }
    if (this.formAccessVisitor.controls['dateStart'].hasError('required') ||
      this.formAccessVisitor.controls['dateEnd'].hasError('required')) {
      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }
    if (this.RadioGroup.value.radioBtn === 'true' && (this.formAccessVisitor.controls['accessApproverId'].value.mdmid === '' || this.formAccessVisitor.controls['accessApproverId'].value.mdmid === undefined || this.formAccessVisitor.controls['accessApproverId'].value.mdmid === null)) {
      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }
    if (this.formRadio.value.document === 'nationalId' && this.formRadio.value.options === 'bulk') {
      if ((this.formRadio.controls['ID'].hasError('validateRUN') || this.formRadio.value.firstName == '' || this.formRadio.value.lastName === '' || this.formRadio.value.email === '')) {
        this.goTo('responsetabsecond');
        this.spinner.hide("loading");
        return;
      }
    }
    if (this.formRadio.controls.email.invalid && this.formRadio.value.options === 'bulk') {
      this.spinner.hide("loading");
      return;
    }


    if (this.formRadio.value.options === 'manual') {
      const AccessRequest = {
        visitorsTypeId: Number(this.formAccessVisitor.value.classification),
        siteId: Number(this.formAccessVisitor.value.siteId),
        zoneId: Number(this.formAccessVisitor.value.zoneId),
        subZoneId: Number(this.formAccessVisitor.value.subZoneId),
        businessUnitId: String(this.formAccessVisitor.value.bussinesUnitID),
        accessApproverId: this.RadioGroup.value.radioBtn === 'false' ? this.ApproverId.value.mdmid : this.formAccessVisitor.value.accessApproverId.mdmid,
        purpose: this.formAccessVisitor.value.purpuse,
        periodFrom: this.transformDate(this.formAccessVisitor.value.dateStart),
        periodTo: this.transformDate(this.formAccessVisitor.value.dateEnd),
        quantityVisitors: this.dataEntry.length,
        facilityApproverId: this.formAccessVisitor.value.facilityApproverId,
        facilityPriority: this.formAccessVisitor.value.facilityPriority,
        people: [],
        isLeader: false
      }

      if (this.formAccessVisitor.controls['Confirm'].hasError('required') &&
        this.formAccessVisitor.controls['Confirm'].value === false) {
        this.spinner.hide("loading");
        return;
      }
      if (this.approverFacilityZone && this.approverFacilityZone.state && this.RadioGroup.value.radioBtn == 'false') {
        AccessRequest.facilityApproverId = this.approverFacilityZone.mdmid;
        AccessRequest.facilityPriority = this.approverFacilityZone.priority;
      } else {
        if (this.approverFacilitySubZone && this.approverFacilitySubZone.state &&
          this.RadioGroup.value.radioBtn == 'true') {
          AccessRequest.facilityApproverId = this.approverFacilitySubZone.mdmid;
          AccessRequest.facilityPriority = this.approverFacilitySubZone.priority;
        }
      }


      for (const item of this.dataEntry) {
        AccessRequest.people.push(item);
      }
      if (AccessRequest.people.length === 0) {
        this.controlPeopleInError = true;
        this.spinner.hide("loading");
        return;
      }
      if (AccessRequest.people.length > this.dataEntry.length) {
        this._snackBar.open('diff data in payload vs dataEntry', '', {
          duration: 3000,
        });
        return;
      }
      this.dataApi.postAccessVisitor(AccessRequest).subscribe((response) => {
        //this.router.navigate(['/']);
        this.router.navigate(['/access-confirmation/' + response.requestNumber]);
        this.spinner.hide("loading");
      }, () => {
        this.spinner.hide("loading");
      })
    }
    if (this.formRadio.value.options === 'bulk') {
      this.controlFirstName = false;
      this.controlLastName = false;
      this.controlEmail = false;
      this.controlNumPeople = false;
      this.radioPress = true;
      this.controlNationalError = false;
      this.controlCountryError = false;
      if (this.formAccessVisitor.controls['Confirm'].hasError('required') &&
        this.formAccessVisitor.controls['Confirm'].value === false) {
        this.spinner.hide("loading");
        return;
      }
      // agregar validaciones para item y el numPeople

      if (this.formRadio.controls['document'].hasError('required')
        || this.formRadio.controls['firstName'].hasError('required')
        || this.formRadio.controls['lastName'].hasError('required')
        || this.formRadio.controls['email'].hasError('required')
        || this.formRadio.controls['numPeople'].invalid) {
        this.spinner.hide("loading");
        return;
      }
      //validar al tiro rut/passport

      if (this.formRadio.value.document === 'passportNumber' &&
        (this.formRadio.controls['document'].hasError('required') ||
          this.formRadio.controls['ID'].hasError('required') ||
          this.formRadio.controls['countryId'].hasError('required'))) {
        return;
      }
      if (this.formRadio.value.document === 'nationalId' && (this.formRadio.controls['document'].hasError('required') ||
        this.formRadio.controls['ID'].hasError('required'))) {
        return;
      }
      const AccessRequest = {
        visitorsTypeId: Number(this.formAccessVisitor.value.classification),
        siteId: Number(this.formAccessVisitor.value.siteId),
        zoneId: Number(this.formAccessVisitor.value.zoneId),
        subZoneId: Number(this.formAccessVisitor.value.subZoneId),
        businessUnitId: String(this.formAccessVisitor.value.bussinesUnitID),
        accessApproverId: this.RadioGroup.value.radioBtn === 'false' ? this.ApproverId.value.mdmid : this.formAccessVisitor.value.accessApproverId.mdmid,
        purpose: this.formAccessVisitor.value.purpuse,
        periodFrom: this.formAccessVisitor.value.dateStart,
        periodTo: this.formAccessVisitor.value.dateEnd,
        quantityVisitors: this.formRadio.value.numPeople,
        facilityApproverId: this.formAccessVisitor.value.facilityApproverId,
        facilityPriority: this.formAccessVisitor.value.facilityPriority,
        people: [],
        isLeader: true
      }
      if (this.approverFacilityZone && this.approverFacilityZone.state && this.RadioGroup.value.radioBtn == 'false') {
        AccessRequest.facilityApproverId = this.approverFacilityZone.mdmid;
        AccessRequest.facilityPriority = this.approverFacilityZone.priority;
      } else {
        if (this.approverFacilitySubZone && this.approverFacilitySubZone.state &&
          this.RadioGroup.value.radioBtn == 'true') {
          AccessRequest.facilityApproverId = this.approverFacilitySubZone.mdmid;
          AccessRequest.facilityPriority = this.approverFacilitySubZone.priority;
        }
      }

      const item = {
        document: this.formRadio.value.document,
        firstName: this.formRadio.value.firstName,
        lastName: this.formRadio.value.lastName,
        email: this.formRadio.value.email,
        nationality: this.formRadio.value.countryId,
        completedForm: "false",
        qualificationStatus: "1"
      }
      if (this.formRadio.value.document === 'nationalId') {
        let IdSPLIT = this.formRadio.value.ID.split('.').join('')
        this.formRadio.controls['ID'].setValue(IdSPLIT)
        Object.assign(item, {
          nationalId: this.formRadio.value.ID,
          nationality: "Chile",
          passportNumber: "",
          phoneNumber: ""
        });
      }
      if (this.formRadio.value.document === 'passportNumber') {
        Object.assign(item, {passportNumber: this.formRadio.value.ID, nationalId: "", phoneNumber: ""});
      }
      AccessRequest.people.push(item);

      this.dataApi.getVisitorPeople(this.formRadio.value.document, this.formRadio.value.ID, this.formRadio.value.countryId, this.oneSapSite).subscribe((data: any) => {
        if (data.visitorIn === true) {
          this.dataApi.postAccessVisitor(AccessRequest).subscribe((response) => {
            this.router.navigate(['/access-confirmation/' + response.requestNumber]);
            this.spinner.hide("loading");
          }, (err) => {
            this.spinner.hide("loading");
            if(err.error.error !== 'Invalid token.') {
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',

              });
            }
          })
        } else {
          this.controlPeopleInError1 = true;
          this.spinner.hide("loading");
          return;
        }
      }, (err) => {
        this.spinner.hide("loading");
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',

          });
        }
      });
    }
  }
}
